import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api, setUserSession, loadCachedAccessSummary } from '../services';
import { usePermission } from '../hooks/usePermission';
import { getFirstAccessibleTenantPath } from '../config/routePermissions';

function PartnerSignIn() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { refresh } = usePermission();
    const [message] = useState('Signing you in…');
    const didRun = useRef(false);

    useEffect(() => {
        if (didRun.current) return;
        didRun.current = true;

        const token = searchParams.get('token');
        if (!token) {
            navigate('/', { replace: true });
            return;
        }

        (async () => {
            try {
                const response = await api.post('/auth/partner-sign-in', { token });
                setUserSession(response.data.token, response.data.user, {
                    refreshToken: response.data.refreshToken,
                    accessTokenExpiresAt: response.data.accessTokenExpiresAt,
                    refreshTokenExpiresAt: response.data.refreshTokenExpiresAt,
                    user_type: response.data.user_type,
                });
                localStorage.removeItem('adminToken');
                window.dispatchEvent(new Event('userLogin'));
                const summary = (await refresh()) || loadCachedAccessSummary();
                const nextRaw = searchParams.get('next') || '';
                const next = nextRaw.startsWith('/') && !nextRaw.startsWith('//')
                    ? nextRaw
                    : '';
                navigate(next || getFirstAccessibleTenantPath(summary), { replace: true });
            } catch {
                navigate('/', { replace: true });
            }
        })();
    }, [navigate, refresh, searchParams]);

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
            <p className="text-muted">{message}</p>
        </div>
    );
}

export default PartnerSignIn;
